import { useAuth0 as useAuth0 } from '@auth0/auth0-react';
import {
  Auth0Hook$loginWithRedirect$ref3n7wxkz3j2ym3 as Auth0Hook$loginWithRedirect$ref,
  Auth0Hook$logout$refnhzladq3aios as Auth0Hook$logout$ref,
} from './External.mjs';
import { AuthHookData2x0lxghdz8ao as AuthHookData } from './AuthHookData.mjs';
import { await3gx2tubo6ckuc as await_0 } from '../../../../../../../../../kotlinx-coroutines-core/kotlinx/coroutines/Promise.mjs';
import { toString30pk9tzaqopn as toString } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { constructCallableReference23y65rf941mch as constructCallableReference } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { to2cs3ny02qtbcb as to } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/Tuples.mjs';
import { json3n35pf5np6si4 as json } from '../../../../../../../../../kotlin-kotlin-stdlib/kotlin/js/json.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function useAuth0Data() {
  var hook = useAuth0();
  var tmp = hook.isAuthenticated === true ? hook.user : null;
  var tmp_0 = hook.isAuthenticated === true;
  var tmp_1 = hook.isLoading === true;
  var tmp_2 = hook.error;
  var tmp_3 = Auth0Hook$loginWithRedirect$ref(hook);
  var tmp_4 = useAuth0Data$slambda(hook);
  var tmp_5 = Auth0Hook$logout$ref(hook);
  return new (AuthHookData())(tmp, tmp_0, tmp_1, tmp_2, tmp_3, tmp_4, tmp_5, useAuth0Data$slambda_0(hook));
}
function *collectRawToken(_this__u8e3s4, $completion) {
  return toString((yield* await_0(_this__u8e3s4, $completion))['__raw']);
}
function useAuth0Data$slambda($hook) {
  return constructCallableReference(function *($completion) {
    var tmp;
    if ($hook.isAuthenticated === true) {
      tmp = yield* /*#__NOINLINE__*/collectRawToken($hook.getIdTokenClaims(), $completion);
    } else {
      tmp = '';
    }
    return tmp;
  }, 0);
}
function useAuth0Data$slambda_0($hook) {
  return constructCallableReference(function *($completion) {
    return yield* await_0($hook.getAccessTokenSilently(json([to('audience', 'https://' + window.location.hostname + '/api'), to('scope', 'email')])), $completion);
  }, 0);
}
//region block: exports
export {
  useAuth0Data as useAuth0Datar84ij8t1ru66,
};
//endregion

//# sourceMappingURL=Dsl.mjs.map
